import { Component, TemplateRef } from '@angular/core';
import { ToastsService } from '@app/core/services/toasts.service';


@Component({
  selector: 'app-toasts-container',
  templateUrl: './toasts-container.component.html',
  host: { class: 'toast-container position-fixed end-0 p-3', style: 'z-index: 1200; top: 64px;' },
})
export class ToastsContainerComponent {
  show = true;

  constructor(public toastsService: ToastsService) { }

  isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }

  close() {
    this.show = false;
    setTimeout(() => (this.show = true), 3000);
  }

}
